<nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow navbar-dark fixed-top"
  [ngClass]="selectedHeaderNavBarClass">
  <div class="navbar-wrapper">
    <div id="navbar-header" class="navbar-header" [ngClass]="selectedNavBarHeaderClass"
      (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)">
      <ul class="nav navbar-nav flex-row">
        <!-- Remove position relative in responsive -->
        <li class="nav-item mobile-menu d-lg-none mr-auto"><a class="nav-link nav-menu-main menu-toggle hidden-xs11"
            (click)="toggleNavigation($event)">
            <i class="feather ft-menu font-large-1"></i></a></li>
        <li class="nav-item mr-auto"><a [routerLink]="['/onlyadminaccess/dashboard']" class="navbar-brand"
            routerLink="/onlyadminaccess/dashboard"><img class="brand-logo" alt="modern admin logo"
              [src]="_themeSettingsConfig.brand.logo.value">
            <h3 class="brand-text">{{_themeSettingsConfig.brand.brand_name}}</h3>
          </a></li>
        <li class="nav-item d-none d-md-block nav-toggle">
          <a [routerLink]="" class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"
            (click)="toggleFixMenu($event)">
            <i class="feather toggle-icon font-medium-3 white"
              [ngClass]="{'ft-toggle-left': _themeSettingsConfig.menu === 'collapse','ft-toggle-right': _themeSettingsConfig.menu === 'expand'}"></i>
          </a>
        </li>
        <li class="nav-item d-lg-none"><a class="nav-link open-navbar-container" data-toggle="collapse"
            data-target="#navbar-mobile" (click)="toggleNavbar($event)"><i class="la la-ellipsis-v"></i></a></li>
      </ul>
    </div>
    <!-- New-->
    <div class="navbar-container content" [hidden]="isMobile && !showNavbar">
      <div class="collapse navbar-collapse" id="navbar-mobile">
        <ul class="nav navbar-nav mr-auto float-left">
          <li class="nav-item d-none d-md-block"><a [routerLink]="" class="nav-link nav-link-expand"
              (click)="toggleFullScreen()" *ngIf="maximize === 'on'"><i class="ficon feather ft-maximize"></i></a></li>
        </ul>

        <ul class="nav navbar-nav float-right">

          <li class="dropdown-notification nav-item dropdown" *ngIf="ofertasLaborales?.length>0" ngbDropdown display="dynamic">
            <a class="nav-link nav-link-label" ngbDropdownToggle>
              <i class="ficon icon-bell"></i>
              <span class="badge badge-pill badge-danger badge-up badge-glow">{{ofertasLaborales?.length}}</span>
            </a>
            <ul class="dropdown-menu-media dropdown-menu-right" ngbDropdownMenu>
              <li class="dropdown-menu-header">
                <h6 class="dropdown-header m-0"><span class="grey darken-2">Ofertas laborales</span></h6><span
                  class="notification-tag badge badge-default badge-danger float-right m-0">{{ofertasLaborales?.length}}</span>
              </li>
              <li class="scrollable-container media-list w-100 ps-container ps-theme-dark ps-active-y" *ngFor="let offer of ofertasLaborales" fxFlex="auto" [perfectScrollbar]="config">
                <a href="javascript:void(0)">
                  <div class="media">
                    <div class="media-left align-self-center"><i class="feather ft-bell icon-bg-circle bg-cyan"></i>
                    </div>
                    <div class="media-body">
                      <h6 class="media-heading">{{offer.empresa}}</h6>
                      <p class="notification-text font-small-3 text-muted">
                        {{offer.descripcionPuesto}}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li *ngIf="ofertasLaborales.length>1" class="dropdown-menu-footer">
                <a class="dropdown-item text-muted text-center" href="javascript:void(0)">Leer todas las ofertas
                  laborales.</a>
              </li>
            </ul>
          </li>

          <!-- <li *ngIf="ofertasLaborales?.length>0" class="dropdown-notification nav-item dropdown" ngbDropdown>
            <a class="nav-link nav-link-label" ngbDropdownToggle>
              <i class="feather ft-bell"></i>
              <span class="badge badge-pill badge-danger badge-up badge-glow">{{ofertasLaborales?.length}}</span>
            </a>
            <ul class="dropdown-menu-media dropdown-menu-right" ngbDropdownMenu>
              <li class="dropdown-menu-header">
                <h6 class="dropdown-header m-0"><span class="grey darken-2">Ofertas Laborales</span></h6><span
                  class="notification-tag badge badge-default badge-danger float-right m-0">5 New</span>
              </li>
              <li class="scrollable-container media-list w-100 ps-container ps-theme-dark ps-active-y" fxFlex="auto"
                [perfectScrollbar]="config" *ngFor="let offer of ofertasLaborales">
                <a href="javascript:void(0)">
                  <div class="media">
                    <div class="media-left align-self-center"><i class="feather ft-bell icon-bg-circle bg-cyan"></i>
                    </div>
                    <div class="media-body">
                      <h6 class="media-heading">{{offer.empresa}}</h6>
                      <p class="notification-text font-small-3 text-muted">
                        {{offer.descripcionPuesto}}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li *ngIf="ofertasLaborales.length>1" class="dropdown-menu-footer">
                <a class="dropdown-item text-muted text-center" href="javascript:void(0)">Leer todas las ofertas
                  laborales.</a>
              </li>
            </ul>
          </li> -->

          <li class="dropdown-user nav-item" ngbDropdown>
            <a class="nav-link dropdown-user-link" ngbDropdownToggle>
              <span class="mr-1 user-name text-bold-700">{{currentUser.nombre}}</span>
              <span class="avatar avatar-online">
                <img src="https://res.cloudinary.com/drtcnv1st/image/upload/v1679537510/Administrador/icono-admin_f66v6w.png"
                  alt="avatar">
                <i></i>
              </span>
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownProfileMenu">
              <a class="dropdown-item" (click)="logout()"><i class="feather ft-power"></i> Cerrar sesión</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>